import { inject, Injectable } from "@angular/core";
import {
  Router,
  GuardsCheckStart,
  Route,
  ActivatedRouteSnapshot
} from "@angular/router";
import { TabCanDeactivateGuard } from "./tab-candeactivate.guard";

@Injectable({ providedIn: "root" })
export class GlobalRouteGuardService {
  private readonly router = inject(Router);

  /** This will help ensure that routes are automatically protected by ensuring that global guards are applied to every route */
  public ensureGlobalGuards() {
    this.router.events.subscribe({
      next: (e: any) => {
        if (e instanceof GuardsCheckStart) {
          let lastChild: ActivatedRouteSnapshot = e.state.root;
          while (lastChild && lastChild.firstChild) {
            lastChild = lastChild.firstChild;
          }

          if (lastChild && lastChild.routeConfig) {
            this.ensureCanDeactivateGuards(lastChild.routeConfig);
          }
        }
      }
    });
  }

  private ensureCanDeactivateGuards(routeConfig: Route) {
    if (!routeConfig.canDeactivate) {
      routeConfig.canDeactivate = [];
    }

    const canDeactivateGuards = routeConfig.canDeactivate;

    if (!canDeactivateGuards.find((o) => o == TabCanDeactivateGuard)) {
      canDeactivateGuards.push(TabCanDeactivateGuard);
    }
  }
}
